import * as React from 'react';

const ListsStatsCardItemDivider = (): JSX.Element => (
  <div className="lists-stats-card-item-divider">
    <div className="lists-stats-card-item-divider__line" />
  </div>
);

export default ListsStatsCardItemDivider;
